import React from 'react'
import { bool } from 'prop-types'
import styled, { css } from 'styled-components'
import { FormattedMessage } from 'react-intl'

import MEDIA from 'styles/media'
import LINKS from './config/links'

const StyledFooter = styled.footer`
  padding-left: 16px;
  margin-top: 20px;
  font-size: 8px;
  line-height: 10px;
  color: ${({ theme }) => theme.primaryFaded};

  ${MEDIA.mobile} {
    padding-left: 0;
    font-size: 12px;
    line-height: 14px;
    color: ${({ theme }) => theme.whiteFaded};
    text-align: left;

    ${({ isSticky }) =>
      isSticky &&
      css`
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 0 22px;
        margin-bottom: 25px;
        color: ${({ theme }) => theme.primaryFaded};
      `};
  }
`

const Links = styled.div`
  & a {
    color: ${({ theme }) => theme.primaryFaded};
    text-decoration: none;

    &:not(:last-of-type)::after {
      content: ' | ';
    }

    ${({ isSticky }) =>
      !isSticky &&
      css`
        ${MEDIA.mobile} {
          color: ${({ theme }) => theme.whiteFaded};
        }
      `}
  }
`

const Footer = ({ isSticky }) => (
  <StyledFooter isSticky={isSticky}>
    <Links isSticky={isSticky}>
      {LINKS.map(({ href, i18n }) => (
        <a key={href} href={href} target='_blank'>
          <FormattedMessage {...i18n} />
        </a>
      ))}
    </Links>
    <div>© {new Date().getFullYear()} Abihome GmbH</div>
  </StyledFooter>
)

Footer.propTypes = {
  isSticky: bool
}

Footer.defaultProps = {
  isSticky: false
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/Footer/index.js